import CatalogMeta from './CatalogMeta';

export default CatalogMeta;
